import { FaHome, FaEnvelope, FaPhone } from "react-icons/fa";
import { Contact as ContactProps } from "../../@types/Contact";
import { HeaderItems as MenuProps } from "../../@types/HeaderItems";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './styles.css'
import SocialMediaIcons from "../SocialMediaIcons";


export default function BottomFooter() {
    const contact: ContactProps[] = [
        {
            key: '1',
            icon: FaHome,
            text: 'Uberlândia-MG - 38400-658',
            href: 'https://goo.gl/maps/nxSzPGiLZP7oyYKHA'
        },
        {
            key: '2',
            icon: FaPhone,
            text: '+55 34 99194-4000',
            href: 'whatsapp://send?text=Olá estou tendo algumas dúvidas, poderia me ajudar?&phone=5534996423233'
        },
        {
            key: '3',
            icon: FaEnvelope,
            text: 'contato@uaigraos.com.br',
            href: 'mailto:contato@uaigraos.com.br'
        }
    ]

    const menuItems: MenuProps[] = [
        {
            key: '1',
            href: '/',
            title: 'Home'
        },
        {
            key: '2',
            href: '/news',
            title: 'Notícias'
        },
        {
            key: '3',
            href: '/partners',
            title: 'Parceiros/Clientes'
        },
        {
            key: '4',
            href: '/contact',
            title: 'Contato'
        },
        {
            key: '5',
            href: '/about',
            title: 'Quem Somos'
        }
    ]

    const currentYear = new Date().getFullYear();

    return (
        <div>
            <footer className="bg-white text-dark pt-5 pb-4 p-3 bg-body-tertiary">
                <Container className="tex-md-left">
                    <Row className="row text-md-left ">
                        <Col md='3' lg='3' xl='3' className="mx-auto mt-3">
                            <h5 className="text-uppercase text-success">UAI GRÃOS</h5>
                            <p>Startup Mineira focada na negociação de grãos com a facilidade de realizar um Barter com a Industria. Temos uma estrutura completa de consultoria para atender a sua colheita até a chegada da Industria.</p>
                        </Col>
                        <Col md='3' lg='2' xl='2' className="mx-auto mt-3">
                            <h5 className="text-uppercase mb-4 font-weight-bold text-success">Links úteis</h5>
                            {menuItems.map((item) => (
                                <div>
                                <p key={item.key}>
                                    <a href={item.href} target='_blank' rel="noreferrer" className='list-item text-decoration-none text-dark'>{item.title}</a>
                                </p>
                                </div>
                            ))}
                        </Col>
                        <Col md='4' lg='3' xl='3' className="mx-auto mt-3">
                            <h5 className="text-uppercase mb-4 font-weight-bold text-success">Contato</h5>
                            {
                                contact.map((item) => (
                                    <a href={item.href} target='_blank' rel="noreferrer" className='text-decoration-none text-dark'>
                                        <p key={item.key}>
                                            <item.icon /> {item.text}
                                        </p>
                                    </a>
                                ))
                            }
                        </Col>
                    </Row>
                    <hr className="mb-4" />
                    <Row className="align-items-center">
                        <Col md='7' lg='8'>
                            <p>
                                <strong className="text-success">Uai Grãos</strong>
                                {' '} &copy;{currentYear} todos os direitos reservados.
                            </p>
                        </Col>
                        <Col md='5' lg='4'>
                            <div className="text-center text-md-right">
                                <ul className="list-unstyled list-inline">
                                    <SocialMediaIcons />
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </div>
    )
}
